export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getAll: state => state.items,
    getByAgency: state => agency => state.items.filter(item => item.agency.id == agency),
    getByAgencyNumber: state => agency => state.items.filter(item => item.agency.internal_number == agency),
    getItem: state => id => state.items.find(item => item.id == id)
  },
  actions: {
    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'business',
        api_data_path: 'businesses',
        namespace: 'business'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous les items via l'API dans le state avec des données limitées. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAllForSelect: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'business/index/simple',
        api_data_path: 'businesses',
        namespace: 'business'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous les items via l'API dans le state avec des données limitées. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait    Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @param   {integer} agency  ID de l'agence pour laquelle récupérer les affaires
     * @returns {promise}         Aucune donnée n'est retournée
     */
    getAllForSelectByAgency: (context, {
      wait = false,
      agency
    }) => {
      let params = {
        wait: wait,
        api_url: 'business/index/simple',
        api_data_path: 'businesses',
        namespace: 'business',
        query: 'agencyid=' + agency
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous les items via l'API dans le state avec des données limitées. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait    Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @param   {integer} agency  Number de l'agence pour laquelle récupérer les affaires
     * @returns {promise}         Aucune donnée n'est retournée
     */
    getAllForSelectByAgencyNumber: (context, {
      wait = false,
      agency, add = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'business/index/simple',
        api_data_path: 'businesses',
        namespace: 'business',
        query: 'agency=' + agency,
        add: add
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {
      id,
      wait = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'business',
        namespace: 'business',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    addItem(context, item) {
      let params = {
        api_url: 'business',
        namespace: 'business',
        item: item
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'business',
        namespace: 'business',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'business',
        namespace: 'business',
        id: id
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/business.js